import {Component, Input} from '@angular/core';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {FieldConfig} from '../../../models/form-config.model';

/**
 * TextareaField — campo di testo multiriga.
 * Non riutilizza CustomInput (che è pensato per input singola riga)
 * ma replica il suo stile floating-label per coerenza visiva.
 */
@Component({
  selector: 'app-textarea-field',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './textarea-field.component.html',
  styleUrl: './textarea-field.component.scss',
})
export class TextareaFieldComponent {
  @Input({required: true}) field!: FieldConfig;
  @Input({required: true}) control!: FormControl;

  readonly uniqueId: string =
    `textarea-${this.field?.key ?? ''}-${Math.random().toString(36).slice(2, 7)}`;
}
